import axios, { AxiosResponse } from "axios";
import LicenceCache from "../components/cache/LicenceCache";
import LicenceDataSource, { smartFetch } from "../datasource/LicenceDataSource";
import { AuthInfo } from "../models/AuthResponse";
import { IChangePasswordViewModel } from "../models/ChangePasswordViewModel";
import { IUser } from "../models/IUser";
import LocalConfig from "../settings/LocalConfig";
import AuthStore from "../store/AuthStore";

const getRequestOptions = (method: string, body: any) => {
    body = JSON.stringify(body);
    let token = localStorage.getItem('token');
    console.log("getRequestOptions.token=" + token);
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        withCredentials: true,
        credentials: 'include',
        method: method,
        body: body,

    }
}

const AccountControllerName = () => {
    const res = LocalConfig.getValue("AccountControllerName", "account");
    return res;
}
export default class AuthService {
    
//    static url = LicenceDataSource.baseUrl + '/jwt';
//    static url = LicenceDataSource.baseUrl + '/account';
    static url = LicenceDataSource.baseUrl + '/' + AccountControllerName();
    static async login(login: string, password: string, authStore: AuthStore) {
        return smartFetch(
            {
                authStore: authStore,
                url: this.url + "/login",
                config: getRequestOptions(
                    "POST",
                    {
                        login: login,
                        password: password,
                    }
                ),
                isReplay: true
            }
        )
    }
    static async refresh(authStore: AuthStore) {
        return smartFetch(
            {
                authStore: authStore,
                url: this.url + "/refresh",
                config: getRequestOptions(
                    "POST",
                    {
                        refreshToken: localStorage.getItem("refreshToken"),
//                        refreshToken: LicenceCache.getItemCache(authStore, "refreshToken"),
                    }
                ),
                isReplay: true
            }
        )
    }
    static async logout(authStore: AuthStore) {
        return smartFetch(
            {
                authStore: authStore,
                url: this.url + "/logout",
                config: getRequestOptions(
                    "POST",
                    { }
                ),
                isReplay: false
            }
        )
    }

    static async editUser(user: IUser, authStore: AuthStore) {
        return smartFetch(
            {
                authStore: authStore,
                url: this.url + "/edit",
                config: getRequestOptions(
                    "POST",
                    user
                ),
                isReplay: false
            }
        )
    }

    static async changePassword(changePasswordViewModel: IChangePasswordViewModel, authStore: AuthStore) {
        return smartFetch(
            {
                authStore: authStore,
                url: this.url + "/changePassword",
                config: getRequestOptions(
                    "POST",
                    changePasswordViewModel
                ),
                isReplay: false
            }
        )
    }


/*
    static async login(email: string, password: string): Promise<AxiosResponse<AuthInfo>> {
        return axios.post<AuthInfo>(this.url + "/login",
            {
                email,
                password
            },
            getRequestOptions()
        );
    }
    static async refresh(): Promise<AxiosResponse<AuthInfo>> {
        return axios.post<AuthInfo>(this.url + "/refresh",
            {
                refreshToken: localStorage.getItem("refreshToken"),
            },
            getRequestOptions()
        );
    }
    static async logout(): Promise<void> {
        return axios.post(this.url + "/logout",
            {
            },
            getRequestOptions()
        );
    }

    static async editUser(user: IUser): Promise<AxiosResponse<AuthInfo>> {
 //       let body = JSON.parse(JSON.stringify(user));
        return axios.post<AuthInfo>(this.url + "/edit",
                user
            ,
            getRequestOptions()
        );
    }

    static async changePassword(changePasswordViewModel: IChangePasswordViewModel): Promise<AxiosResponse<AuthInfo>> {
        return axios.post<AuthInfo>(this.url + "/changePassword",
            changePasswordViewModel
            ,
            getRequestOptions()
        );
    }
*/
}